let increaseSpeedFunction: () => void = () => {};
let decreaseSpeedFunction: () => void = () => {};

export default function useChangeBallSpeedFunctions(decrease: () => void, increase: () => void) {
  decreaseSpeedFunction = decrease;
  increaseSpeedFunction = increase;
}

export { increaseSpeedFunction, decreaseSpeedFunction };
